import { FormGroup } from '@angular/forms';

export class ProfileSkill {
  public title: string = '';
  public level: string = '100';
  public levelPercentage: string = '';

  public static parseForm(form: FormGroup): ProfileSkill {
    let skill = new ProfileSkill();
    skill = Object.assign(skill, form.value);
    return skill;
  }

  public static parse(jsonData): ProfileSkill {
    let skill = new ProfileSkill();
    skill = Object.assign(skill, jsonData);

    if (skill.level) {
      skill.levelPercentage = `${skill.level.toString()}%`;
    }

    return skill;
  }
}
